import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Masks from '../../../../utils/masks';
import {
  Button,
  Grid,
  Input,
  DataGrid,
  Table,
} from '../../../../components/index';
import { formatarCnpj } from '../../../../utils/helpers';
import {
  getObject,
  situacaoOrgaoVinculado,
} from '../../../../utils/listsSelect';
import {
  doPost,
  trataMensagensErro,
} from '../../../../utils/requests';
import OrgaoVinculado from './OrgaoVinculado';

class OrgaoVinculados extends Component {
  constructor() {
    super();
    const initialState = this.getInitialState();
    this.state = initialState;
  }

  getInitialState = () => ({
    acaoModal: 'criacao',
    showModal: false,
    cnpjOrgao: null,
    nomeOrgao: null,
    errosOrgaoVinculadoSelecionado: null,
    orgaoVinculadoSelecionado: null,
  })

  handleModal = () => {
    this.setState({ showModal: !this.state.showModal, acaoModal: this.state.acaoModal });
  }

  handleSearchButton = () => {
    this.handleSearch();
  }

  handleSearch = () => {
    let paramCnpj = '';
    let paramNome = '';
    if (this.state.cnpjOrgao) {
      paramCnpj = this.state.cnpjOrgao.toUpperCase();
      if (this.state.cnpjOrgao.indexOf('_') !== -1) {
        paramCnpj = this.state.cnpjOrgao.toString().replace(/_/g, '');
      }
    }
    if (this.state.nomeOrgao) {
      paramNome = this.state.nomeOrgao.toUpperCase();
    }
    this.state.cnpjOrgao = paramCnpj;
    this.state.nomeOrgao = paramNome;
    const parametros = {
      codigo: this.props.estadoFormulario.regimeProprio.idParticipante,
      cnpjFiltro: paramCnpj,
      nomeFiltro: paramNome,
    };
    this.buscarCNPJNomeOrgao(parametros);
  }

  buscarCNPJNomeOrgao = (parametros) => {
    const url = 'participantes-rpps/codigo/';
    doPost(url, parametros, this.handleSucessBuscarCNPJNomeOrgao, this.handleErrorBusca);
  }

  preparaRequest = (urlRelatorio, parametros, callback) => {
    doPost(
      urlRelatorio,
      parametros,
      callback,
      this.tratarErro,
    );
  }

  handleSucessBuscarCNPJNomeOrgao = (response) => {
    let listaOrgaosVinculados = [];
    if (response.data.orgaosVinculados.length > 0) {
      listaOrgaosVinculados = response.data.orgaosVinculados.map(item => ({
        cnpj: item.cnpj,
        nomeOrgaoVinculado: item.nomeOrgaoVinculado,
        situacao: item.situacao,
      }));
    }
    this.props.handleChangeOrgaosVinculados(listaOrgaosVinculados, 'orgaosVinculados');
  }

  handleChange = (changeObj, name) => {
    this.setState({
      [name]: changeObj.value,
    });
  }

  createCustomInsertButton = orgao => (
    <React.Fragment>
      {(this.props.auth.checkPermission(['analisar-negocio-sprev'])) ?
        <Button
          hint="Adicionar Orgão Vinculado"
          icon="ico-user-plus"
          onClick={() => this.incluirOrgaoVinculado(orgao)}
        />
        : ''}
    </React.Fragment>
  );

  createActionColumn = (indice, orgao) => (
    <React.Fragment>
      {(this.props.auth.checkPermission(['analisar-negocio-sprev'])) ?
        <Button
          hint="Editar Orgão Vinculado"
          icon="ico-pencil"
          mini
          onClick={() => this.editOrgaoVinculado(indice, orgao)}
        />
        : ''}
    </React.Fragment>
  );

  addSituacaoLabel = (situacaoSelecionado) => {
    const obj = getObject(situacaoOrgaoVinculado, situacaoSelecionado);
    let valorlabel = null;
    if (obj) {
      valorlabel = obj.label;
    }
    return valorlabel;
    // const obj = getObject(situacao, situacaoSelecionado);
    // return obj.label;
  }

  /**
   * Determina quais colunas devem ser exibidas na tabela de dependentes
   */
  montaOrgaoVinculadoTableHeader = () => {
    const tableHeader = [{
      id: 'cnpj',
      label: 'CNPJ',
    }, {
      id: 'nomeOrgaoVinculado',
      label: 'Orgão',
    }, {
      id: 'situacao',
      label: 'Situação',
      dataFormat: this.addSituacaoLabel,
    }];
    if (this.props.auth.checkPermission(['analisar-negocio-sprev'])) {
      tableHeader.push({
        id: 'acoes',
        label: 'Ações',
        dataFormat: this.createActionColumn,
      });
    }
    return tableHeader;
  }

  options = {
    hideSizePerPage: true,
    insertBtn: this.createCustomInsertButton,
    noDataText: 'Nenhum Orgão foi adicionado à lista',
    sizePerPage: 5,
  };

  /**
   * Adiciona Orgao Vinculado a lista
   * FLAG OPERACAO = 1 - INCLUSAO
   * FLAG OPERACAO = 2 - ALTERACAO
   */
  addOrgaoVinculado = (orgao, edit) => {
    const { orgaosVinculados } = { ...this.props };
    if (edit) {
      const orgaoVinculado = { ...orgao };
      if (orgaoVinculado.situacao === '') {
        orgaoVinculado.situacao = 0;
        orgaoVinculado.flagOperacao = 2;
      } else {
        orgaoVinculado.flagOperacao = 2;
      }
      orgaosVinculados[this.state.cell] = orgaoVinculado;
    } else {
      let orgaoExisteNaLista = false;
      // const cnpjNovoOrgao = orgao.cnpj.replace(/(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/, '$1.$2.$3/$4-$5');
      const cnpjNovoOrgao = orgao.cnpj.replace(/^(.{2})(.{3})(.{3})(.{4})(.{2})$/, '$1.$2.$3/$4-$5');
      orgaosVinculados.forEach((orgaoExistente) => {
        const orgaoAux = orgaoExistente;
        orgaoAux.cnpj = orgaoExistente.cnpj;
        if (orgaoAux.cnpj === cnpjNovoOrgao) {
          trataMensagensErro(['O orgão já foi cadastrado anteriormente.']);
          orgaoExisteNaLista = true;
        }
      });
      if (orgaoExisteNaLista === false) {
        const orgaoInclusao = orgao;
        orgaoInclusao.flagOperacao = 1;
        // orgaoInclusao.idParticipante = null;
        orgaosVinculados.unshift(orgaoInclusao);
      }
    }
    this.alteraListaOrgaosVinculados(orgaosVinculados, null);
  }

  /**
   * Altera um orgao da lista
   */
  editOrgaoVinculado = (indice, orgaoVinculadoSelecionado) => {
    let errosOrgaoVinculadoSelecionado = null;
    if (this.props.errosOrgaoVinculado) {
      errosOrgaoVinculadoSelecionado = this.props.errosOrgaoVinculado
        .filter(erro => erro.indiceLista === indice);
    }
    this.setState({
      cell: indice,
      acaoModal: 'edicao',
      orgaoVinculadoSelecionado,
      errosOrgaoVinculadoSelecionado,
    }, this.handleModal);
  }

  /**
   * inclui um orgao da lista
   */
  incluirOrgaoVinculado = () => {
    // orgaoVinculado.idParticipante = this.props.estadoFormulario.regimeProprio.idParticipante;
    // const paramOrgao = orgaoVinculado;
    // paramOrgao.idParticipante = this.props.estadoFormulario.regimeProprio.idParticipante;
    this.setState({
      // orgaoVinculadoSelecionado: paramOrgao,
      acaoModal: 'criacao',
    }, this.handleModal);
  }

  alteraListaOrgaosVinculados = (listaOrgaosVinculados, errosOrgaosVinculados) => {
    if (errosOrgaosVinculados) {
      this.props.validacaoErrosOrgaoVinculado(errosOrgaosVinculados, true);
    }
    this.props.handleChangeOrgaosVinculados(listaOrgaosVinculados, 'orgaosVinculados');
  }

  /**
   * Remove a selecao do dependente
   */
  resetOrgaoVinculadoSelecionado = () => {
    this.setState({
      orgaoVinculadoSelecionado: null,
      acaoModal: null,
      errosOrgaoVinculadoSelecionado: null,
    });
  }


  render() {
    const listaOrgaosVinculadosIndexada =
      this.props.orgaosVinculados.map((item, i) => {
        const itemIndexado = item;
        itemIndexado.acoes = i;
        // itemIndexado.cnpj = itemIndexado.cnpj.replace(/(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/, '$1.$2.$3/$4-$5');
        itemIndexado.cnpj = formatarCnpj(itemIndexado.cnpj);
        return itemIndexado;
      });

    const modalOrgaoVinculado = this.state.showModal ?
      (<OrgaoVinculado
        acaoModal={this.state.acaoModal}
        acao={this.props.acao}
        addOrgaoVinculado={this.addOrgaoVinculado}
        orgaoVinculado={this.state.orgaoVinculadoSelecionado}
        errosOrgaoVinculado={this.state.errosOrgaoVinculadoSelecionado}
        validacaoErrosOrgaoVinculado={this.props.validacaoErrosOrgaoVinculado}
        onHide={this.handleModal}
        resetOrgaoVinculado={this.resetOrgaoVinculadoSelecionado}
        showModal
      />
      ) : null;
    return (
      <DataGrid title="Dados dos Orgãos Vinculados" icon="ico-users" >
        <div className="row">
          <Grid cols="4 4 4 4">
            <Input
              // cnpjOrgao
              // integer
              label="CNPJ do Orgão Vinculado"
              mask={Masks.cnpj}
              value={this.state.cnpjOrgao}
              onChange={e => this.handleChange(e, 'cnpjOrgao')}
              showMask
              validationState="active"
            />
          </Grid>
          <Grid cols="6 6 6 6">
            <Input
              nomeOrgao
              label="Nome do Orgão Vinculado"
              value={this.state.nomeOrgao}
              onChange={e => this.handleChange(e, 'nomeOrgao')}
            />
          </Grid>
        </div>
        <div className="row">
          <Button
            className="dtp-primary right"
            title="Pesquisar"
            onClick={() => this.handleSearchButton()}
          />
        </div>
        <Table
          bordered
          data={listaOrgaosVinculadosIndexada}
          insertRow="true"
          options={this.options}
          listaTableHeader={this.montaOrgaoVinculadoTableHeader()}
          pagination
          fetchInfo={this.fetchInfo}
        />
        {modalOrgaoVinculado}
      </DataGrid>
    );
  }
}

OrgaoVinculados.propTypes = {
  acao: PropTypes.string.isRequired,
  estadoFormulario: PropTypes.objectOf(PropTypes.object).isRequired,
  handleChangeOrgaosVinculados: PropTypes.func.isRequired,
  errosOrgaoVinculado: PropTypes.arrayOf(PropTypes.object).isRequired,
  validacaoErrosOrgaoVinculado: PropTypes.func.isRequired,
  auth: PropTypes.objectOf(PropTypes.object).isRequired,
  orgaosVinculados: PropTypes.arrayOf({
    cnpj: PropTypes.string,
    nome: PropTypes.string,
    situacao: PropTypes.number,
  }).isRequired,
};

export default OrgaoVinculados;



// WEBPACK FOOTER //
// ./src/pages/cadastros/EntesFederativos/Rpps/OrgaosVinculados.jsx